import { Molecule } from 'openchemlib/full';
export async function readMolfile(file, options = {}) {
    const result = readMolfileText(await file.text());
    if (result.molecules.length === 0) {
        options.logger?.debug(`${file.name} is an empty molfile`);
    }
    return result;
}
export function readMolfileText(originalMolfile) {
    const result = {
        molecules: [],
        spectra: [],
    };
    if (isMolfileNotEmpty(originalMolfile)) {
        const molecule = Molecule.fromMolfile(originalMolfile);
        molecule.addImplicitHydrogens();
        const molfile = molecule.toMolfile();
        result.molecules.push({ molfile });
    }
    return result;
}
function isMolfileNotEmpty(molFile) {
    if (!molFile || !molFile.match(/V[23]0/))
        return false;
    return true;
}
//# sourceMappingURL=readMolfile.js.map